<!--16 Suchen per Liste-->
<dx-lookup
  placeholder="{{'SuchKriterium' | translate}}"
  [searchEnabled]="false"
  [items]="searchValues"
  [displayExpr]="getSearchValueDisplayExpr"
  [(value)]="searchValue">
</dx-lookup>

<div class="chk-grid">
  <div class="chk-item">
    <div>Trennzeichen ","</div>
    <dx-check-box
      [hint]="' , '"
      [(value)]="kommaTrennzeichen"
    >
    </dx-check-box>
  </div>



  <div class="chk-item">
    <div>Trennzeichen ";"</div>
    <dx-check-box
      [hint]="' ; '"
      [(value)]="semikolonTrennzeichen"
    >
    </dx-check-box>
  </div>
</div>

<div *ngIf="searchValue != 'MANUFACTURER_NAME'">
  <div class="dx-text-area-coloured w-100">
    <dx-text-area [value]="inputList"
                  (onValueChanged)="onValueChangedFormatListIgnoreSpace($event,kommaTrennzeichen,semikolonTrennzeichen)"
                  valueChangeEvent="input"
                  [height]="400">
    </dx-text-area>
  </div>
</div>

<div class="dx-field">
  <div *ngIf="searchValue == 'MANUFACTURER_NAME'">
    <dx-load-panel #loadPanel
                   shadingColor="rgba(0,0,0,0.4)"
                   [position]="{ of: '#list', at: 'center' }"
                   [(visible)]="loadingVisible"
                   [showIndicator]="true"
                   [showPane]="true"
                   [shading]="true"
                   [hideOnOutsideClick]="false"></dx-load-panel>

    <div class="dx-text-area-coloured w-100" id="list">
      <dx-list [dataSource]="manufacturerDataSource"
               [noDataText]="getNoDataText()"
               [allowItemDeleting]="false"
               [showSelectionControls]="true"
               selectionMode="all"
               showCheckBoxesMode="selectAll"
               [(selectedItems)]="selectedManufacturer"
               [searchEnabled]="true"
               searchMode="contains"></dx-list>
    </div>
  </div>
</div>
